// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TopPanel__topPanelContainer___hRZWK{box-shadow:0 4px 4px rgba(0,0,0,.05);display:flex;flex-direction:column;overflow:hidden;z-index:1}.TopPanel__topPanelContainer___hRZWK,.TopPanel__topPanelHeader___2C_Vg{background-color:var(--spectrum-global-color-gray-50)}.TopPanel__topPanelHeader___2C_Vg{height:auto!important;padding:10px 20px!important}.TopPanel__topPanelHeader___2C_Vg{border:none;width:100%}.TopPanel__topPanelContent___1oJ33{flex:1 1;max-height:0;overflow-y:auto;transition:max-height .5s ease-in}.TopPanel__panelEnterActive___2moxU,.TopPanel__panelEnterDone___24Dqo{max-height:400px;transition-timing-function:ease-in}.TopPanel__panelExitActive___3f_E6{max-height:0;transition-timing-function:ease-in}", ""]);
// Exports
exports.locals = {
	"topPanelContainer": "TopPanel__topPanelContainer___hRZWK",
	"topPanelHeader": "TopPanel__topPanelHeader___2C_Vg",
	"topPanelContent": "TopPanel__topPanelContent___1oJ33",
	"panelEnterActive": "TopPanel__panelEnterActive___2moxU",
	"panelEnterDone": "TopPanel__panelEnterDone___24Dqo",
	"panelExitActive": "TopPanel__panelExitActive___3f_E6"
};
module.exports = exports;
